export default __webpack_public_path__ + "static/media/SD-srisailatv-iframe-img.42d8f18b.png";